import { Box, Typography } from '@mui/material';
import { num } from '../format';
import { useConversionPlatform } from '../hooks/useConversionPlatform';
import { COLORS, cardSx } from '../theme';

/**
 * Conversion Funnel.
 *
 * Renders only when the active filters resolve to exactly one platform that has
 * conversions, and names that platform in the heading. Anything else — several
 * platforms in scope, no conversions, or a query still in flight — renders
 * nothing at all.
 *
 * Nothing, deliberately: this previously sat directly under the headline numbers
 * showing a permanent "not yet wired" card, so an empty widget was the first
 * thing on the page. A placeholder that is always empty teaches people to scroll
 * past the slot, and it would keep the page height jumping as filters change.
 * Returning null keeps the layout honest — the funnel appears exactly when there
 * is a figure we can stand behind.
 *
 * Conversions cannot be summed across DSPs, so the single-platform rule is a
 * correctness constraint, not a display preference. See useConversionPlatform.
 */
const OutcomesStrip = () => {
  const { platform, conversions, loading } = useConversionPlatform();

  if (loading || !platform) return null;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <Typography variant='subtitle1' sx={{ fontWeight: 600, color: COLORS.text }}>
        Conversion Funnel · {platform}
      </Typography>
      <Box
        className='rv2-card'
        sx={{
          ...cardSx,
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5,
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Typography variant='h5' sx={{ fontWeight: 600, color: COLORS.text }}>
          {num(conversions)}
        </Typography>
        <Typography variant='caption' sx={{ color: COLORS.muted }}>
          Conversions attributed to {platform} for the current filters.
        </Typography>
      </Box>
    </Box>
  );
};

export default OutcomesStrip;
